import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Module, ModuleDto } from '@app/store/shared/models';
import { ModuleValue, ModuleValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getModule(id: string): Observable<Module> {
        return this.httpClient.get<ModuleDto>(`modules/${id}`).pipe(map((dto) => new Module(dto)));
    }

    createModule(value: ModuleValue): Observable<Module> {
        const dto = new ModuleValueDto(value);

        return this.httpClient.post<ModuleDto>('modules', dto).pipe(map((response) => new Module(response)));
    }

    updateModule(id: string, value: ModuleValue): Observable<Module> {
        const dto = new ModuleValueDto(value);

        return this.httpClient.patch<ModuleDto>(`modules/${id}`, dto).pipe(map((response) => new Module(response)));
    }

    deleteModule(id: string): Observable<void> {
        return this.httpClient.delete<void>(`modules/${id}`);
    }
}
